<script>
    /*
    	DataSelectField.svelte
    */

    import { onMount } from 'svelte';
    import { getFieldStyle } from '../../common/data-fields.js';

    // TCARE components

    // SMUI components
    import Tooltip, { Wrapper } from '@smui/tooltip';
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiClose, mdiChevronRightBox } from '@mdi/js';


    // change these for <select> fields?

    export let value;           // two way binding for the input changes
    export let choices;         // source array for preset values
    export let propName;        // pass to onCopyValue for field to use
    export let label;           // the caption for the field
    export let isEditable;      // if false show as gray disabled
    export let isOrigDiff;      // if true show strike-thru
    export let isNewDiff;       // if true show yellow highlight
    export let onCopyValue;     // null or external setter function
    export let tooltip;         // if not blank will show in popover
    export let showDiffs;       // bypass the strike-through and highlighting

    let originalValue;

    $: isDirty = originalValue !== value;
    $: fieldStyle = getFieldStyle(isEditable, isOrigDiff, isNewDiff, isDirty, showDiffs);
    // $: selectStyle = getSelectStyle(isEditable, isOrigDiff, isNewDiff, isDirty);

    // set originalValue one time only!
    onMount(() => {
        originalValue = value;                      // might be null

        // console.log('');
        // console.log('DataSelectField onMount');
        // console.log('value:');
        // console.log(value);
    });

    // TODO: must also reset the store, not just the field's value!
    // correction - because this is bound, the store is getting reset
    // 8/25 - MUST MAKE AN ARRAY FIELD TYPE (SIMILAR TO TAXONOMYFIELD)
    const resetValue = () => {
        value = originalValue;
    }

    const _onCopyValue = () => {
        if (onCopyValue) onCopyValue(propName);              // call parent function
    }

    const _onSelectChange = () => {
        if (value === '') value = null;
    }

    // this does not seem to work - still tries to open dropdown
    const _onSelectFocus = (e) => {
        if (!isEditable) e.target.blur();
    }


</script>

<style>

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="data-field">
    <div class="label">
        {label}
    </div>

    <!-- only show tooltip if there is text there! -->
    <div class="value">
        <Wrapper>
            <select class="ellipsis" bind:value={value} style={fieldStyle}
                on:change={_onSelectChange} 
                on:focus={_onSelectFocus} 
            >
                <!-- only show dropdown options if isEditable -->
                {#if isEditable}
                    {#if choices}
                        {#each choices as choice}
                            <option>{choice}</option>
                        {/each}
                    {/if}
                {:else}
                    <!-- need at least one option to show value -->
                    {#if value}
                        <option>{value}</option>
                    {/if}
                {/if}
            </select>
            {#if tooltip && tooltip !== ''}
                <Tooltip xPos="start" yPos="above">{tooltip}</Tooltip>
            {/if}
        </Wrapper>
    </div>

    <div class="icons">
        <!-- the "copy to" icon - call parent's function -->
        {#if onCopyValue}
            {#if value && value !== ''}
                <div class="icon" on:click={_onCopyValue}>
                    <Icon component={Svg} viewBox="0 0 24 24" >
                        <path d={mdiChevronRightBox} />
                    </Icon>
                </div>
            {/if}
        {/if}

        {#if isEditable && isDirty}
            <div class="icon" on:click={() => resetValue()}>
                <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiClose} /></Icon>
            </div>
        {/if}
    </div>
</div>
